<template>
  <div class="login_wrap">
    <div class="login-hd">
      <slot name="title" />
      <span v-if="!$slots.title" class="title" />
      <span class="btn_close" @click="clickClosePage">
        <i class="sprite-icon sprite-icon-close" />
      </span>
    </div>
    <!-- 快速登录 -->
    <div v-if="isQuickLogin" class="quick-login">
      <h1>
        <i class="sprite-icon sprite-icon-link" />检测到您上次登录账号，
        <em>点击头像</em>一键登录
      </h1>
      <div class="user-record-list">
        <div
          v-for="(item, index) in recentLoginList"
          :key="index"
          :class="{ 'user-record-selected': index === 0 }"
          class="user-record"
          @click="clickQuickLogin(index, item)"
        >
          <div class="user-record-lt">
            <div class="avatar-wrap">
              <div v-if="!item.avatar" class="not-login-avatar sprite-icon sprite-icon-avatar" />
              <img v-else :src="item.avatar" class="avatar">
              <i v-if="item.is_vip" class="sprite-icon sprite-icon-vip-logo vip" />
            </div>
            <div class="user-name-wrap">
              <p class="user-name">
                {{ item.nickname }}
              </p>
              <span
                v-if="registerFrm[item.register_frm]"
                class="register-frm"
              >{{ registerFrm[item.register_frm] }}</span>
            </div>
          </div>
          <span class="del" title="删除上次登录信息" @click.stop="removeUserInfo(index)">
            <i class="sprite-icon sprite-icon-del" />
          </span>
        </div>
      </div>
      <div class="quick-login-ft">
        <p class="other" @click="clickGiveUpQuickLogin">
          使用其他账号登录
        </p>
      </div>
    </div>
    <!-- end 快速登录 -->

    <!-- 手动登录 -->
    <div class="manual-login">
      <div class="login_types">
        <div class="tabs">
          <p
            v-for="(item, index) in tabs"
            :key="index"
            :class="{ active: loginType === item.type }"
            class="tab"
            @click="clickTabSwitch(item.type)"
          >
            {{ item.value }}
          </p>
        </div>
        <div v-show="loginType === 'wechat'" class="wechat_type">
          <div id="qrcode" class="qrcode" />
          <span class="title">微信扫一扫登录</span>
        </div>
        <div v-show="loginType === 'mobile'" class="message_type">
          <form
            v-show="!showCaptcha"
            autocomplete="off"
            method="post"
            novalidate="true"
            @submit.prevent.enter="clickMobileLogin"
          >
            <ul>
              <li class="first-li">
                <input
                  id="mobile"
                  v-model="mobile"
                  name="mobile"
                  placeholder="输入手机号码"
                  type="text"
                  @blur="checkForm(1)"
                >
              </li>
              <li class="li_error">
                {{ errors[0] }}
              </li>
              <li>
                <input
                  id="verify"
                  v-model="verify"
                  class="verify"
                  maxlength="6"
                  name="verify"
                  placeholder="输入验证码"
                  type="text"
                  @blur="checkForm"
                >
                <a
                  :class="{ disabled: isActive }"
                  rel="noopener noreferrer"
                  class="btn_send"
                  @click.prevent="clickSendVerify"
                >{{ showBtnText }}</a>
              </li>
              <li class="li_error">
                {{ errors[1] }}
              </li>
              <li class="last-li">
                <input class="btn_login" type="submit" value="登录">
              </li>
            </ul>
          </form>
          <!-- showCaptcha 显示时间 -->
          <form
            v-show="showCaptcha"
            autocomplete="off"
            method="post"
            novalidate="true"
            @submit.prevent.enter="submitCaptcha"
          >
            <span class="title">请输入下方面板的字母及数字继续</span>
            <ul>
              <li class="captcha-li">
                <span class="captcha-img-wrap">
                  <img v-if="captchaUrl" :src="captchaUrl" alt>
                </span>
                <span class="change-captcha" @click="changeCaptcha">
                  <i class="sprite-icon sprite-icon-change change" />换一换
                </span>
              </li>
              <li>
                <input
                  id="captcha"
                  v-model="captcha"
                  name="captcha"
                  placeholder="请输入图片验证码"
                  type="text"
                >
              </li>
              <li class="li_error">
                {{ captchaError }}
              </li>
              <li>
                <input class="btn_login" type="submit" value="下一步">
              </li>
            </ul>
          </form>
        </div>
      </div>
      <div class="manual-ft">
        <div class="agree">
          <label for="ckbagree">登录即同意</label>
          <a :href="privacyLink" rel="noopener noreferrer" target="_blank">《会员服务使用协议》</a>
        </div>
        <p class="other">
          其他方式登录
        </p>
        <div class="other-icons">
          <div class="btn_qq" @click="clickQQLogin">
            <i class="sprite-icon sprite-icon-qq btn_qq" />
            <span>QQ</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="qqIfmUrl" class="qq_login_wrap">
      <a rel="noopener noreferrer" class="btn_close" @click="clickCloseQQIfm" />
      <iframe :src="qqIfmUrl" title="QQ登录" class="ifm" />
    </div>
  </div>
</template>

<script>
import { stringifyQuery } from '@shared/utils/querystring'
import { WxLogin } from '@/plugins/wechat/wxLogin'
import {
  checkCaptchaApi,
  getCaptchaApi,
  getToken,
  sendVerifyCode,
} from '@/api/login'
import { getRecentLoginList, removeRecentLoginList } from '@/utils/cache'
import {
  bindEventPostMessage,
  publishPageClose,
  publishPageLoaded,
  publishUserInfo,
} from '@/postMessage'
import EventEmit from '@/utils/EventEmit'

import _qqAuth from '@/plugins/auth/qqAuth.js'
import * as LoginHandler from '@/service/login/loginHandler'

/* QQ和微信用的跳转地址，在微信后台和QQ后台都配置了该地址的白名单 */
const PROXY_URL = 'https://wpvip.ijinshan.com/vip_login_proxy_v2.html'
const QQ_PROXY_URL = 'https://newvip.ijinshan.com/vip_login_proxy_v2.html'
const DOMAIN = `${window.location.protocol}//${window.location.host}/`

const ERROR_NO_CAPTCHA = '请输入图片验证码'
const ERROR_ERROR_CAPTCHA = '图片验证码错误'
const REGISTER_FRM_TO_LOGIN_TYPE = {
  0: 'unknown',
  1: 'wechat',
  2: 'qq',
  3: 'mobile',
  90: 'old_vip',
}

const REGISTER_FRM = {
  0: '未知',
  1: '微信',
  2: 'QQ',
  3: '手机',
  90: '老会员',
}

export default {
  name: 'UserLogin',
  data() {
    return {
      privacyLink: 'http://www.ijinshan.com/privacy/memberServerUser.html',
      white: true,
      draggableStyle: 'height: 50px; padding-top: 10px;',
      hideFeedback: true,
      errors: [],
      mobile: null,
      verify: null,
      send: false,
      isActive: false,
      count: -1, // 发送验证码按钮文本
      timer: null,
      startTime: 0,
      showCaptcha: false,
      errorTimes: 0,
      maxErrorTimes: 1,
      captchaError: '',
      captcha: '',
      captchaUrl: '',
      checkLoginTimer: null,
      tabs: [
        { type: 'wechat', value: '微信登录' },
        { type: 'mobile', value: '手机登录' },
      ],
      loginType: 'wechat',
      isQuickLogin: false,
      recentLoginList: getRecentLoginList(),
      registerFrm: REGISTER_FRM,
      qqIfmUrl: '',
    }
  },
  computed: {
    showBtnText() {
      switch (this.count) {
        case -1:
          return '获取验证码'
        case -2:
          return '发送中...'
        case -3:
          return '重发送验证码'
        default:
          return `${this.count}s后重试`
      }
    },

    validCode() {
      const re = /^\d{6}$/
      return re.test(this.verify)
    },

    validPhone() {
      const mobileRule = /(?:^1[3456789]|^9[28])\d{9}$/
      return mobileRule.test(this.mobile)
    },

    urlStopWinClose() {
      return this.stopWinClose || this.$route.query.stopWinclose
    },
  },
  mounted() {
    bindEventPostMessage()
    publishPageLoaded()

    this.startTime = new Date().getTime()
    this.createQrcode()

    EventEmit.$on('LOGIN', (res) => {
      this.qqIfmUrl = ''

      if (!(res && res.resp_common && res.resp_common.ret === 0)) {
        this.$toast('登录失败，请重试', {
          duration: 2000,
          callback: () => {
            this.startTime = new Date().getTime()
            this.createQrcode()
          },
        })
      } else {
        this.$toast('登录成功~')
        // console.log('登录成功:', res)
        this.$store.dispatch('setUserInfo', res.data.user_info)
        this.clickClosePage()
      }
    })
  },
  methods: {
    // 点击QQ登录
    clickQQLogin() {
      const paramStr = stringifyQuery({
        type: 'qq',
        postmessage_domain: DOMAIN,
        postmessage_type: 'opener',
        time: new Date().getTime(),
      })

      const url = new _qqAuth({
        client_id: '101554059', // 申请QQ登录成功后，分配给应用的appid。
        responseType: 'token', // 授权类型，此值固定为“token”
        scope: 'get_user_info',
        redirectUri: `${QQ_PROXY_URL}?${paramStr}`,
      }).getAuthUrl()
      console.log(`${QQ_PROXY_URL}?${paramStr}`)
      // this.qqIfmUrl = url
      window.open(url)
      // reportClickQQLogin()
    },

    // 点击-头像一键登录
    clickQuickLogin(index, loginItem) {
      let click = ''
      if (index === 0) {
        click = '9'
      } else if (index === 1) {
        click = '10'
      } else if (index === 2) {
        click = '11'
      }
      if (click) {
        // reportClickQuickLogin({ click })
      }

      const registerFrm = loginItem.register_frm
      const loginType = REGISTER_FRM_TO_LOGIN_TYPE[registerFrm] || 'unknown'

      LoginHandler.quickLogin({ token: loginItem.token, userInfo: loginItem })
        .then((res) => {
          res = Object.assign(
            {
              data: {
                login_type: '',
              },
            },
            res,
          )
          res.data.login_type = loginType

          this.handleTip(res)

          publishUserInfo(res)
          EventEmit.$emit('LOGIN', res)
        })
        .catch(() => {
          // console.error(e)
          publishUserInfo({
            resp_common: { ret: -100, msg: 'request fail' },
            data: {
              login_type: loginType,
            },
          })
        })
    },
    // 点击-关闭 QQ iframe
    clickCloseQQIfm() {
      this.qqIfmUrl = ''
    },
    // 点击-手机-登录
    clickMobileLogin() {
      if (!this.checkForm()) return
      if (this.errors.length) return

      LoginHandler.login({ tel: this.mobile, tel_code: this.verify })
        .then((res) => {
          res = Object.assign(
            {
              data: {
                login_type: '',
              },
            },
            res,
          )
          res.data.login_type = 'mobile'
          this.handleTip(res)

          publishUserInfo(res)
          EventEmit.$emit('LOGIN', res)
        })
        .catch(() => {
          // console.error(e)
          publishUserInfo({
            resp_common: { ret: -100, msg: 'request fail' },
            data: {
              login_type: 'mobile',
            },
          })
        })
    },
    // 微信二维码
    createQrcode() {
      const paramStr = stringifyQuery({
        type: 'wechat',
        postmessage_domain: DOMAIN,
        postmessage_type: 'parent',
        time: new Date().getTime(),
      })

      // eslint-disable-next-line no-new
      new WxLogin({
        id: 'qrcode', // 放置微信二维码图片的容器id，例如<div id="login_container"></div>
        appid: 'wx6e611384771e4e6c',
        scope: 'snsapi_login',
        redirect_uri: encodeURIComponent(`${PROXY_URL}?${paramStr}`), // 微信回调地址
        self_redirect: true,
        style: 'black',
        href:
          'data:text/css;base64,LmltcG93ZXJCb3gge3RleHQtYWxpZ246IGxlZnQ7fQouaW1wb3dlckJveCAucXJjb2RlIHt3aWR0aDogMTcwcHg7IG1hcmdpbi10b3A6IDA7IGJvcmRlcjogbm9uZTt9Ci5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9Ci5pbXBvd2VyQm94IC5pbmZvIHtkaXNwbGF5OiBub25lO30KLnN0YXR1c19pY29uIHtkaXNwbGF5OiBub25lfQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fQog',
      })
    },
    checkTokenForQuickLogin() {
      if (this.recentLoginList) {
        const promiseArr = []
        this.recentLoginList.forEach((item) => {
          promiseArr.push(
            getToken({
              common: {
                token: item.token,
                open_id: item.open_id,
              },
            }),
          )
        })

        Promise.all(promiseArr).then((resList) => {
          resList.forEach((res, index) => {
            if (!res || !res.resp_common || res.resp_common.ret !== 0) {
              this.recentLoginList.splice(index, 1)
              removeRecentLoginList(index)
            }
          })
          if (this.recentLoginList.length > 0) {
            this.isQuickLogin = true
          }
        })
      }
    },

    // 点击-使用其他账号登录
    clickGiveUpQuickLogin() {
      this.isQuickLogin = false
      // reportClickGiveUpQuickLogin()
    },

    // 点击-发送验证码
    async clickSendVerify() {
      if (this.count === -1) {
        // reportClickSendVerify()
      }
      if (!(this.checkForm(1) && !this.send)) return

      const params = {
        mobile: this.mobile,
        captcha: this.captcha || '0000',
      }
      const data = await sendVerifyCode(params)
      if (data) {
        this.errorTimes = data.mobile_calc ? data.mobile_calc : this.errorTimes
        this.maxErrorTimes = data.mobile_max_calc
          ? data.mobile_max_calc
          : this.maxErrorTimes

        if (this.errorTimes > this.maxErrorTimes) {
          this.showCaptcha = true
          this.getCaptcha()
          return
        }
        this.send = true
        this.count = -2
        this.countDown()
      }
    },
    removeUserInfo(index) {
      removeRecentLoginList(index)
      this.recentLoginList.splice(index, 1)
      if (this.recentLoginList.length <= 0) {
        this.isQuickLogin = false
      }
    },
    handleTip(res) {
      if (!res && res.resp_common) return

      const ret = res.resp_common.ret

      if (ret === 3001002) {
        this.$set(this.errors, 1, '验证码错误')
      } else if (ret === 5903006) {
        // 登录限制
        this.$toast(
          `登录设备达到上限，同一会员账号允许最多在${res.limit}台设备登录`,
          { duration: 2000, callback: () => {} },
        )
      }
    },
    sendVerify() {
      this.send = true
      this.count = -2
      this.countDown()
      const params = {
        mobile: this.mobile,
        captcha: this.captcha || '0000',
      }
      // 延时1秒发送请求, 因为服务端需要1秒后才重置错误次数
      setTimeout(() => {
        sendVerifyCode(params)
      }, 1000)
    },
    countDown() {
      let count = 60
      this.timer = setInterval(() => {
        if (count === 0) {
          this.reset()
          return
        }
        this.count = count--
        this.isActive = true
      }, 1000)
    },
    reset() {
      this.send = false
      this.isActive = false
      clearInterval(this.timer)
      this.count = -3
    },
    checkForm(type) {
      this.errors = []
      if (!this.mobile) {
        this.errors[0] = '请输入手机号'
        return false
      } else if (!this.validPhone) {
        this.errors[0] = '请输入正确手机号'
        return false
      }
      if (`${type}` === '1') {
        return true
      }
      if (!this.verify) {
        this.errors[1] = '请输入验证码'
        return false
      } else if (!this.validCode) {
        this.errors[1] = '请输入6位数字'
        return false
      }
      return true
    },
    // 点击顶部tab切换（微信登录、手机登录）
    clickTabSwitch(loginType) {
      if (this.loginType === loginType) return

      this.loginType = loginType
    },
    clickClosePage() {
      publishPageClose()
      EventEmit.$emit('HIDE_LOGIN_DIALOG')
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    },
    async getCaptcha() {
      const res = await getCaptchaApi({
        mobile: this.mobile,
      })
      if (res && res.resp_common && res.resp_common.ret === 0 && res.captcha) {
        this.captchaUrl = res.captcha
        this.captcha = ''
      }
    },
    changeCaptcha() {
      // 获取验证码
      this.getCaptcha()
    },
    async submitCaptcha() {
      if (this.checkCaptchaForm()) {
        const res = await checkCaptchaApi({
          mobile: this.mobile,
          captcha: this.captcha,
        })

        if (res && res.resp_common && res.resp_common.ret === 0) {
          if (res.status === 1) {
            this.showCaptcha = false
            this.captchaError = ''

            this.errorTimes = res.mobile_calc
              ? res.mobile_calc
              : this.errorTimes
            this.maxErrorTimes = res.mobile_max_calc
              ? res.mobile_max_calc
              : this.maxErrorTimes

            // 验证正确，发送短信
            this.sendVerify()
          } else {
            this.captchaError = ERROR_ERROR_CAPTCHA
          }
        } else {
          this.captchaError = ERROR_ERROR_CAPTCHA
        }
      }
    },
    checkCaptchaForm() {
      if (!this.captcha) {
        this.captchaError = ERROR_NO_CAPTCHA
        return false
      }
      return true
    },
  },
}
</script>

<style scoped lang="scss">
.login_wrap {
  position: relative;
  box-sizing: border-box;
  width: 350px;
  height: 480px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.25);
  .login-hd {
    position: relative;
    box-sizing: border-box;
    height: 50px;
    overflow: hidden;
    border-top: 6px solid #fdd63c;
    -webkit-app-region: drag;
    .title {
      position: absolute;
      top: 7px;
      left: 12px;
      font-size: 12px;
      color: #b07400;
    }
    .btn_close {
      position: absolute;
      right: 0;
      width: 24px;
      height: 24px;
      overflow: hidden;
      cursor: pointer;
      -webkit-app-region: no-drag;
      i {
        position: relative;
      }
      &:hover {
        i {
          left: -24px;
        }
      }
      &:active {
        i {
          left: -48px;
        }
      }
    }
  }
  .btn_login {
    width: 244px;
    height: 38px;
    font-size: 16px;
    line-height: 38px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    background: #de461e;
    border: none;
    border-radius: 30px;
    outline: none;
    box-shadow: none;
  }
  .qq_login_wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 750px;
    height: 390px;
    margin-top: -195px;
    margin-left: -375px;
    background: #fff;
    .btn_close {
      position: absolute;
      top: 16px;
      right: 16px;
      z-index: 100;
      width: 16px;
      height: 16px;
      cursor: pointer;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAQCAYAAABQrvyxAAABxUlEQVRIS9WWvS5FQRSFv5WgpFJSatQUxBtQiPhpaDyBgvAEgoQXoFH5jcYboFJrtHRUSiQjW2bknHNn5px7iXC7O+fsnPXNrL1mi3/+k+l3zu0AT8CepLcck3OuG1gB+iWt+vob4AFYkvRaU98DHAIDksZ9/TLwAlxIeq+p7wKmgV5JBwFgDZgAboHNFIQXvw6MAteStryAI2AeuARmUhDOORN/BkwBJ5KsxjZwFhgG7v16FMI5Z+LngCHgTtJpALBd3QBGUhAV8SVQL+wcmExBVMSXQCvCohCpdz4B/C4kIXLiC/W2u1GInPhCfXF3SxA5wC+AFIT/QLBNncVaIHx9sE2dxVogfH2wTcvplAASEM57Pis+cxJWb57Pis+chD0yz0et1QIQgbClRuITELbcSHwCwpaTzZ0DCLbpFCDY5ncBIg1rApLpVM3sSMPaK8l0itRX+6C5hWJp4z+QjdiKdUoN659lIzaXRI2buCbnm9wTxUuqmvPJiP2RGG2Y87l7Iim+4T2RvAPqADsZJYKdriRt+9RqZ5QIdjqWtODrvz1K2DD3DOx+Y5h7BBbbGOYGJY15gE6GuT5J+9EYrSbDX/7/ARGpjiCSELpBAAAAAElFTkSuQmCC);
    }
    .ifm {
      width: 100%;
      height: 100%;
    }
  }
}
.quick-login {
  position: relative;
  width: 282px;
  height: 430px;
  margin: 0 auto;
  text-align: center;
  h1 {
    font-size: 16px;
    line-height: 30px;
    color: #797979;
    text-align: left;
    .sprite-icon-link {
      margin-right: 10px;
    }
  }
  em {
    margin: 0 4px;
    font-style: normal;
    color: #de461e;
  }
  .user-record-list {
    margin-top: 24px;
  }
  .user-record {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    margin-bottom: 10px;
    cursor: pointer;
    background-color: #f4f6fa;
    border-radius: 4px;
    &:hover {
      background-color: #dfe1e6;
    }
    .user-record-lt {
      display: flex;
      align-items: center;
    }
    .avatar-wrap {
      position: relative;
      width: 60px;
      height: 60px;
      margin-right: 16px;
      .not-login-avatar,
      .avatar {
        display: block;
        width: 100%;
        height: 100%;
        cursor: pointer;
        border-radius: 50%;
      }
      .vip {
        position: absolute;
        right: -10px;
        bottom: 0;
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
    }
    .user-name-wrap {
      text-align: left;
      .user-name {
        margin-bottom: 4px;
        font-size: 14px;
        color: #797979;
      }
      .register-frm {
        display: inline-block;
        padding: 0 4px;
        font-size: 10px;
        line-height: 14px;
        color: #929292;
        border: 1px solid #c4c4c4;
        border-radius: 2px;
      }
    }
    .del {
      display: inline-block;
      width: 24px;
      height: 24px;
      overflow: hidden;
      cursor: pointer;
      i {
        position: relative;
      }
      &:hover {
        i {
          left: -24px;
        }
      }
      &:active {
        i {
          left: -48px;
        }
      }
    }
  }
  .user-record-selected {
    background-color: #dfe1e6;
  }
  .quick-login-ft {
    margin-top: 33px;
    .other {
      margin-top: 25px;
      font-size: 14px;
      font-weight: bold;
      color: #575757;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
.manual-login {
  .login_types {
    height: 270px;
    overflow: hidden;
  }
  .tabs {
    display: flex;
    align-items: center;
    justify-content: center;
    .tab {
      width: 99px;
      margin: 0 10px;
      font-size: 16px;
      line-height: 34px;
      color: #797979;
      text-align: center;
      cursor: pointer;
      border-bottom: 2px solid #fff;
    }
    .active {
      color: #de461e;
      border-color: #de461e;
    }
  }
  .wechat_type {
    padding-top: 17px;
    text-align: center;
    .title {
      display: inline-block;
      font-size: 18px;
      line-height: 34px;
      color: #797979;
    }
    iframe {
      width: 170px;
      height: 170px;
    }
    .qrcode {
      width: 170px;
      height: 170px;
      margin: 0 auto;
      overflow: hidden;
    }
  }
  .message_type {
    width: 252px;
    margin: 0 auto;
    .title {
      display: inline-block;
      margin: 10px 0 6px;
      font-size: 12px;
      color: #797979;
    }
    li {
      height: 40px;
      &.li_error {
        height: 16px;
        margin-top: 2px;
        font-size: 12px;
        color: #ff3f3f;
      }
    }
    .first-li {
      padding-top: 28px;
    }
    .last-li {
      margin-top: 6px;
    }
    .captcha-li {
      width: 254px;
      height: 50px;
      margin-bottom: 9px;
      .captcha-img-wrap,
      img {
        display: inline-block;
        width: 210px;
        height: 50px;
        vertical-align: middle;
      }
      .change-captcha {
        display: inline-block;
        width: 36px;
        margin-left: 8px;
        font-size: 12px;
        color: #636d78;
        text-align: center;
        vertical-align: middle;
        .change {
          display: inline-block;
          width: 26px;
          height: 29px;
          cursor: pointer;
        }
      }
    }
    input[type='text'] {
      box-sizing: border-box;
      width: 252px;
      height: 38px;
      padding-left: 10px;
      font-family: 'MicrosoftYaHei', 'Microsoft YaHei', 'Arial', '\9ED1\4F53',
        '\5B8B\4F53', '\5FAE\8F6F\96C5\9ED1', sans-serif;
      border: solid 1px #d0d0d0;
      outline: none;
      box-shadow: none;
      &::selection {
        color: #fff;
        background: #2593ff;
      }
    }
    input[type='text'].verify {
      width: 149px;
    }
    .btn_send {
      position: relative;
      top: -1px;
      box-sizing: border-box;
      display: inline-block;
      width: 97px;
      height: 38px;
      margin-left: 4px;
      font-size: 12px;
      line-height: 36px;
      color: #de461e;
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      background: #fff;
      border: solid 1px #d0d0d0;
      &:hover {
        border-color: #de461e;
      }
    }
    .disabled {
      color: #fff;
      cursor: auto;
      background-color: #ddd;
      border-color: #ddd;
      &:hover {
        border-color: #ddd;
      }
    }
  }
  .manual-ft {
    width: 180px;
    margin: 0 auto;
    font-size: 12px;
    color: #636d78;
    .other {
      margin: 20px 0;
    }
    .other-icons {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #636d78;
      text-align: center;
    }
    .btn_qq,
    .btn_vip {
      cursor: pointer;
      span {
        display: block;
        line-height: 20px;
        color: #797979;
      }
      i {
        display: inline-block;
        width: 48px;
        height: 48px;
        &:hover {
          background-position: -48px 0;
        }
        &:active {
          background-position: -96px 0;
        }
      }
    }
    .agree {
      display: flex;
      align-items: center;
      font-size: 12px;
      label {
        display: flex;
        align-items: center;
      }
      a {
        color: #b07400;
      }
    }
  }
}
</style>
